import React, { Component } from 'react';
import Downshift from "downshift";
import AxiosFetcher from '../components/axiosFetcher';

function XIcon() {
  return (
    <svg
      viewBox="0 0 20 20"
      preserveAspectRatio="none"
      width={12}
      fill="transparent"
      stroke="#979797"
      strokeWidth="1.1px"
    >
      <path d="M1,1 L19,19" />
      <path d="M19,1 L1,19" />
    </svg>
  )
}

class Autocomplete extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Downshift
        itemToString={item => (item ? item.name : '')}
        onSelect={selection => {
          let newStateValue = { id: undefined, label: undefined }
          if (selection) { newStateValue = { id: selection.id, label: selection.name } }

          this.props.updateFilterField({
            target: { name: this.props.stateField, value: newStateValue.id, label: newStateValue.label }
          })
        }}
      >
        {({
          inputValue,
          getInputProps,
          getMenuProps,
          getItemProps,
          highlightedIndex,
          selectedItem,
          isOpen,
          clearSelection
        }) => {
          return (
            <div>
              <div>
                <input
                  type="text"
                  placeholder={this.props.placeholder}
                  {...getInputProps({ isOpen })}
                />

                {selectedItem ? (
                  <a onClick={clearSelection} aria-label="clear selection">
                    {XIcon()}
                  </a>
                ) : null}
              </div>

              <ul {...getMenuProps(isOpen)}>
                {(() => {

                  if (!isOpen) { return null }

                  if (!inputValue) {
                    return (
                      <li disabled>You have to enter a search query</li>
                    );
                  }

                  return (
                    <AxiosFetcher url={this.props.endpoint} params={{ keyword: inputValue }}>
                      {({ loading, error, data: { list = [] } = {} }) => {

                        if (loading) { return <li disabled>Loading...</li> }

                        if (error) { return <li disabled>Error! ${error}</li> }

                        if (!list.length) { return <li disabled>{`No ${this.props.domain} found`}</li> }

                        return list.map((item, index) => (
                          <li
                            key={item.id}
                            {...getItemProps({
                              item,
                              index,
                              isActive: highlightedIndex === index,
                              isSelected: selectedItem === item,
                            })}
                          >
                            {item.name}
                          </li>
                        ))
                      }}
                    </AxiosFetcher>
                  )
                })()}
              </ul>
            </div>
          );
        }}
      </Downshift>
    )
  }
}
export default Autocomplete;
